//export const URL = "http://62.171.128.232/";  // Тест Семёна
//export const URL = "http://89.250.82.219/";
// export const URL = "https://api.locate.kz/"; // Тест Prem Solutions
export const URL = "https://api.eco-almaty.kz/"; // боевой
//export const URL = "http://rzn/";  // Локально
export const URL_API = `${URL}api/`;
